import type { UserInputValidationError } from '@tectonics/prs/validation';

import { isDirectDebitSelected, validateRequiredDirectDebitField } from './direct-debit-required-field';

const ACCOUNT_NUMBER_REGEX = /^\d{10}$/;

export function validateNigerianAccountNumber(
  selectedPaymentMethod: string,
  selectedEwallet: string,
  accountNumberValue: string
): UserInputValidationError | undefined {
  const requiredFieldError = validateRequiredDirectDebitField(selectedPaymentMethod, selectedEwallet, accountNumberValue);

  if (requiredFieldError || !isDirectDebitSelected(selectedPaymentMethod, selectedEwallet)) {
    return requiredFieldError;
  }

  if (!ACCOUNT_NUMBER_REGEX.test(accountNumberValue)) {
    return { id: 'invalid-pattern' };
  }

  return undefined;
}
